/*!
 * Drive Marketing Custom Scripts
 */

//PS: don't rename this file without updating gulp and webpack.

import '@babel/polyfill';

/*******************************************************
 *
 * Forms
 * Step one: import form prerequisites
 * Step two: load translations
 * Step three: load all your forms
 *
 *******************************************************/

/*
//******************************************************
//Step one: import form stuff

//Dependancies
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VeeValidate from 'vee-validate';
Vue.use(VueI18n);
import enValidationMessages from 'vee-validate/dist/locale/en';
import frValidationMessages from 'vee-validate/dist/locale/fr';

import {default as drive} from './components/drive';
import {default as contactForm} from './components/contactForm';
import {default as businessForm} from './components/businessForm';

//Step two: load translations and form data
let edits, timestamp;
Promise.all([
	drive.fetchEdits().then((response) => { edits = response; })
	, drive.fetchTimestamp().then((response) => { timestamp = response; })
])
	.then(() => {
		Vue.use(VeeValidate, {
			aria: true,
			classes: true,
			classNames: {
				//valid: 'is-valid',
				invalid: 'is-invalid'
			},
			//i18nRootKey: 'validations', // customize the root path for validation messages.
			i18n: edits,
			dictionary: {
				en: enValidationMessages,
				fr: frValidationMessages
			}
		});

		//******************************************************
		//Step three: load all your forms
		//******************************************************

		new Vue({
			el: '#contactFormContainer',
			components: {
				'contactForm': contactForm
			}
		});

		let businessFormContainers = document.querySelectorAll('.businessFormContainer');

		businessFormContainers.forEach(function (element) {
			new Vue({
				el: element
				, components: {
					'businessForm': businessForm
				}
				, data: {
					timestamp: timestamp
				}
				, i18n: edits
			});
		});
	});
 */

/**
 * Polyfill for object-fit in IE
 */
import objectFitImages from 'object-fit-images';
objectFitImages();

/**
 * Add blog pagination once the page loads
import loadMoreArticles from './components/loadMoreArticles';
document.addEventListener('DOMContentLoaded', function () {
	var loadMoreArticlesButton = document.getElementById('more-articles');
	if (loadMoreArticlesButton !== null && typeof loadMoreArticlesButton !== 'undefined') {
		loadMoreArticlesButton.addEventListener('click', function (event) {

			let lastPostID = loadMoreArticlesButton.dataset.lastpostid,
				categoryID = loadMoreArticlesButton.dataset.categoryid,
				languageIndex = loadMoreArticlesButton.dataset.languageindex,
				baseDomain = loadMoreArticlesButton.dataset.basedomain,
				baseUrl = loadMoreArticlesButton.dataset.baseurl;

			//Save HTML contents of button for later
			let loadMoreArticlesButtonLabel = loadMoreArticlesButton.childNodes;

			//Create spinner
			let spinner = document.createElement('i');
			spinner.className = 'fa fa-circle-o-notch fa-spin';

			event.preventDefault();

			//Replace contents of loadMoreArticlesButton with spinner
			while (loadMoreArticlesButton.firstChild) {
				loadMoreArticlesButton.removeChild(loadMoreArticlesButton.firstChild);
			}
			loadMoreArticlesButton.appendChild(spinner);

			loadMoreArticles.loadMoreArticles(lastPostID, categoryID, languageIndex, baseDomain, baseUrl)
				.then(function (response) {
					let posts, newPost, newPostIndex;
					let currentPosts = document.getElementsByTagName('article');
					let lastPost = currentPosts.item(currentPosts.length - 1);

					//Turn HTML response into DOM nodes
					let postsHolder = document.createElement('div');
					postsHolder.insertAdjacentHTML('beforeend', response.data.html);
					posts = postsHolder.getElementsByTagName('article');

					//Avoid button jumping down instead of sliding down with animate.css
					loadMoreArticlesButton.classList.add('animated');
					loadMoreArticlesButton.classList.add('fadeOut');

					//At about the time that the button is hidden...
					setTimeout(function () {
						for (newPostIndex = 0; newPostIndex < posts.length; newPostIndex++) {
							newPost = posts.item(newPostIndex);

							//... Prepare to be animated, blog post!
							newPost.classList.add('animated');
							newPost.classList.add('fadeInUp');

							//Add post. Animation will happen as soon as it's added
							lastPost.insertAdjacentElement('afterend', newPost);
							//Set new placeholder for nest blog post
							lastPost = posts.item(newPostIndex);
						}
					}, 250);


					// We update the markup for our next AJAX call
					loadMoreArticlesButton.dataset.lastpostid = response.data.lastPostID;
					loadMoreArticlesButton.dataset.categoryid = response.data.categoryID;
					while (loadMoreArticlesButton.firstChild) {
						loadMoreArticlesButton.removeChild(loadMoreArticlesButton.firstChild);
					}
					loadMoreArticlesButtonLabel.forEach(function (element) {
						loadMoreArticlesButton.appendChild(element);
					});

					//If not last page, bring back "load more" button
					if (!response.data.isLastPage) {
						loadMoreArticlesButton.classList.remove('fadeOut');
						loadMoreArticlesButton.classList.add('slow');
						loadMoreArticlesButton.classList.add('fadeInUp');
					}

				})
				.catch(function (error) {
					console.log(error);
				});

		});
	}

});
 */

import Cookies from 'js-cookie';

document.addEventListener('DOMContentLoaded', function () {
	let cookieNotice = document.getElementById('cookieNotice');
	let cookieNoticeButton = document.querySelector('#cookieNotice .alert-closebtn');

	if (Cookies.get('closeGdpr') !== 'true') {
		cookieNotice.classList.remove('hidden');
	}

	cookieNoticeButton.addEventListener('click', () => {
		Cookies.set('closeGdpr', 'true');
		cookieNotice.classList.remove('fadeIn');
		cookieNotice.classList.add('fadeOut');
		cookieNotice.classList.add('hidden');
	});
});


